import { VERSION_SOFTWARE_INFO_DATA } from "Constants";
import { DEFAULT_PACKAGE_DATA, DEFAULT_PROJECT_DATA } from "./constants";
import { MoveData } from "./types";

export const getDefaultMoveData = (fileId: string): MoveData => ({
  ...DEFAULT_PROJECT_DATA,
  ...DEFAULT_PACKAGE_DATA,
  ...VERSION_SOFTWARE_INFO_DATA,
  filestream_file_id: fileId,
});
